export default function Calendar(theme) {
    return {
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    margin: '0px',
                    '& .MuiIconButton-root': {
                        padding: '8px',
                        color: '#757575',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '& svg': {
                            fontSize: '20px',
                        }
                    }
                }
            }
        },
        MuiPickersPopper: {
            styleOverrides: {
                paper: {
                    borderRadius: '12px !important',
                    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1) !important',
                    border: '1px solid #E2E8F0',
                }
            }
        },
        MuiDateCalendar: {
            styleOverrides: {
                root: {
                    fontFamily: 'Lato',
                }
            }
        },
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    fontFamily: 'Lato',
                    borderRadius: '8px',
                    '&.Mui-selected': {
                        backgroundColor: `${theme.palette.primary.darker}!important`,
                        '&:hover': {
                            backgroundColor: `${theme.palette.primary.highlight}!important`,
                        },
                    },
                    '&.MuiPickersDay-today': {
                        borderColor: `${theme.palette.primary.darker}!important`,
                        borderWidth: '1px',
                    }
                }
            }
        }
    };
}